// extracted by mini-css-extract-plugin
export default {"button":"getOfferBack_button__KpUoP"};